import { render, staticRenderFns } from "./p-landing-page-c.vue?vue&type=template&id=35e5aeea&"
import script from "./p-landing-page-c.vue?vue&type=script&lang=js&"
export * from "./p-landing-page-c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports